import type {
    RefreshCommerceOrderRequest,
    RefreshCommerceOrderResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const refreshCommerceOrderOperation = defineCommerceOperation<
    RefreshCommerceOrderRequest,
    RefreshCommerceOrderResponse
>("commerce.orders.refresh");
